import { Reducer } from "redux";

import { DocumentSourceResponse } from "../models/Api/Master";
import { DocumentSourceForFilterDispatchTypes } from "../models/DispatchTypes/Master";
import { DocumentSourceForFilterActionDispatchTypes } from "../constants/Master";

const initialState: DocumentSourceResponse = {
  loading: false,
  response: [],
};

const DocumentSourceForFilterReducer: Reducer<
  DocumentSourceResponse,
  DocumentSourceForFilterDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentSourceForFilterActionDispatchTypes.GET_DOCUMENT_SOURCE_FOR_FILTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentSourceForFilterActionDispatchTypes.GET_DOCUMENT_SOURCE_FOR_FILTER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DocumentSourceForFilterActionDispatchTypes.GET_DOCUMENT_SOURCE_FOR_FILTER_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DocumentSourceForFilterReducer;
